/**
 * Compactação da fila: merge de summaries, dedupe heartbeat.
 */

import type { QueueItem } from '../queue';

const MERGE_TYPES = new Set(['BEHAVIOR_SUMMARY']);

export function compactQueueItems(items: QueueItem[]): QueueItem[] {
  const byKey = new Map<string, QueueItem>();
  const rest: QueueItem[] = [];

  for (const item of items) {
    if (!MERGE_TYPES.has(item.params.type)) {
      rest.push(item);
      continue;
    }
    const key = `${item.params.sessionId}:${item.params.type}`;
    const existing = byKey.get(key);
    if (!existing || item.createdAt > existing.createdAt) {
      byKey.set(key, item);
    }
  }

  return [...rest, ...byKey.values()];
}

export function dedupeHeartbeatInBuffer(
  items: QueueItem[]
): QueueItem[] {
  const seen = new Set<string>();
  const out: QueueItem[] = [];
  for (let i = items.length - 1; i >= 0; i--) {
    const item = items[i];
    if ((item.params.type as string) !== 'HEARTBEAT') {
      out.unshift(item);
      continue;
    }
    const key = item.params.sessionId;
    if (seen.has(key)) continue;
    seen.add(key);
    out.unshift(item);
  }
  return out;
}
